/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const ticketMessageSchema = z.object({
  id: z.string(),
  sender: z.enum(['user', 'admin']),
  text: z.string(),
  createdAt: z.number(),
});

export type ITicketMessage = z.infer<typeof ticketMessageSchema>;
